import axiosInstance from '@/lib/axiosInstance';
import { IBlog } from '@/types/blog';

interface IParams {
  filter?: Record<string, string>;
  sort?: string;
  limit?: number;
  skip?: number;
}

interface IMeta {
  total: number;
  limit: number;
  page: number;
  totalPages: number;
}

const getBlogs = (params: IParams, url?: string) => {
  return axiosInstance.get<{ data: IBlog[]; meta: IMeta }>(
    url ?? `/api/blogs`,
    {
      params,
    }
  );
};

export const blogsAPI = {
  getBlogs,
};
